/**
 * 系统管理  菜单信息
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>菜单信息</el-breadcrumb-item>
    </el-breadcrumb>
    <el-tree :data="datatree" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
  </div>
</template>

<script>
import {
  permissionList,
  ermissionSave,
  ermissionDelete,
  roleDropDown,
  RolePermission
} from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      datatree:[],
      type:
        {
          type:''
        },
      childList:[],
      childListchild:[],
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  watch: {},

  /**
   * 创建完毕
   */

  created() {
    this.getdata()
  },

  /**
   * 里面的方法只有被调用才会执行
   */

  methods: {
    // 获取数据方法
    getdata() {
      this.loading = true

      // 获取权限列表
      permissionList(this.type)
        .then(res => {
          this.loading = false

          if (res.code !=0) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {


            this.datatree = [];
            for(var i=0;i<res.data.length;i++){

              if(res.data[i].childList!=null){
                //二级菜单
                this.childList=[];
                for(var j=0;j<res.data[i].childList.length;j++){
                  if(res.data[i].childList[j].childList!=null){
                    //三级权限
                    this.childListchild=[];
                    for(var k=0;k<res.data[i].childList[j].childList.length;k++){

                      this.childListchild.push({label: res.data[i].childList[j].childList[k].name})

                    }
                  }
                  this.childList.push({label: res.data[i].childList[j].name, children:this.childListchild})
                }
              }
              this.datatree.push({label: res.data[i].name, children: this.childList});
            }
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('菜单信息获取失败，请稍后再试！')
        })
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/views/system/Permission.vue